import * as React from 'react';
import classnames from 'classnames';

import styles from './styles.module.css';

export interface AboutRecommendationsProps {
  className?: string;
}

/**
 * @name AboutRecommendations
 * @description Context for the about recommendations engine and process.
 */
export const AboutRecommendations = (props: AboutRecommendationsProps) => {
  const { className } = props;

  // Styles
  const tailwind = `bg-stormy`;
  const cssComponent = classnames(tailwind, styles.component, className);
  const cssHeading = classnames('about-heading', styles.heading);

  return (
    <div className={cssComponent}>
      <div className="ui-container-lg">
        <div className={styles.container}>
          <h2 className={cssHeading}>
            Our recommendations are not just Clean.
            <br />
            <span className="text-pine">
              They’re <span className="whitespace-nowrap">Clean-For-You</span>.
            </span>
          </h2>
          <p>
            Our recommendations evolved from Simran’s original personal “cheat
            sheet” and we’ve continued to refine our selection philosophy. Only
            the products we love, trust, would put on our own skin and recommend
            to our own friends make the cut.
          </p>
          <p>
            We look for clean ingredients but feel like “clean” is not enough.
            It also needs to work for you. Something might be too strong for
            your sensitive skin, or too aggravating for your acneic skin. So we
            believe in Clean-For-You. Not only should ingredients be clean, but
            they should work for your unique skin needs. That’s where our magic
            lies.
          </p>
        </div>
      </div>
    </div>
  );
};
